export default __webpack_public_path__ + "static/media/D.2cd4fbb6.svg";